import { useEffect, useState } from "react";
import ModalComponent from "../common/Modal/modal";
import { Col } from "reactstrap";
import { useDispatch } from "react-redux";
import { setLoading } from "../../store/slices/auth";
import { getFormVariables, postRules } from "./apiController";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import { CreateRulesElements } from "./FormElements";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import MonacoEditorWrapper from "../dataAnalysis/CodeEditor";
import { colorCodes, ComputeOperatorsData } from "../common/utils/ConfigOperators";


const CreateRules = (props) => {
     const { selectedFormId, prevRules, fetchRules } = props;
     const [prevData, setPrevData] = useState(prevRules)
     const [rules, Setrules] = useState<any>([]);
     const [formvariables, setformVariables] = useState<any>([]);
     const dispatch = useDispatch();
     const [code, setCode] = useState<string>('');
     const [tempCode, settempCode] = useState<string>('');
     const [lineData, setlineData] = useState<any>({})
     const [action, setaction] = useState('');
     const [moreOption, setmoreOption] = useState(false);
     let data = "";

     const [values, fields, handleChange, { validateValues, updateValue, updateError, removeErrors }] =
          useFieldItem(CreateRulesElements, {}, { onValueChange });

     let ComputeOperators = ComputeOperatorsData;

     ComputeOperators = [...ComputeOperators, ...props.variables, ...colorCodes]
     useEffect(() => {
          console.log("CREAT", props)
          fetchFormVariables(selectedFormId)

          //add initial row
          if (prevData && prevData.length == 0) {
               addRules();
               fetchPrevious("");
          }
     }, [])

     /**
      * fetch previosu data and set rules
      */
     const fetchPrevious = (varData) => {
          let tempString: string = "";
          let tempCodeString: string = "";
          let tempCodeData: string = "";

          console.log(prevData)
          prevData && prevData.map((item, i) => {
               console.log(item.split('endrule')[1] + 'endrule')
               if (i == 0) {
                    tempString += item.split('endrule')[1] + 'endrule'
                    tempCodeString += item.split('endrule')[0] + 'endrule'

               } else {
                    tempString += '\n' + item.split('endrule')[1] + 'endrule'
                    tempCodeString += '\n' + item.split('endrule')[0] + 'endrule'
               }
          })

          console.log(tempCodeString)
          tempCodeString.split(' ').map((item, i) => {

               let exitData = props.variables.filter(flt => flt.id == item)
               console.log(exitData)
               if (item == "endrule" || item == "endrule\n") {
                    tempCodeData += item
               } else {
                    if (exitData && exitData.length > 0) {
                         tempCodeData += exitData[0].value + '$$'
                    } else {
                         tempCodeData += item + '$$'
                    }
               }
               console.log(item)
          })
          setCode(tempString)
          settempCode(tempCodeData)
          data = tempCodeData;
          console.log(tempCodeData)

     }

     /**
   * on value change for form fields
   * @param name 
   * @param value 
   * @param values 
   * @param fieldValues 
   * @returns 
   */
     function onValueChange(name, value, values, fieldValues = null) {
          let resetValue = {};
          console.log(values)
          return [
               {
                    ...values,
                    ...resetValue,
                    [name]: value,
               },
          ];
     }


     /**
      * on submit form 
      * @param e 
      * finalArray = [{field1:value,field2:value,operator:value,field2_type:value}]
      */
     const onAdd = async () => {
          console.log(tempCode)
          try {
               let objString = "";
               let finalArray: any = [];
               let count = 0;
               console.log(tempCode)

               tempCode.split('$$').map(itm => {
                    //   console.log(itm)
                    //count for avoid variable check on message
                    if (itm == ":") {
                         count = count + 1;
                    }
                    // console.log("Count---", props.variables)

                    let exitData = props.variables.filter(flt => flt.value == itm)
                    if (itm != " ") {
                         if (exitData.length > 0) {
                              objString += exitData[0].id + ' '
                         } else {
                              objString += itm + ' '
                         }
                    }

               })
               console.log(objString.trim())


               code.split('endrule').map((item, i) => {
                    console.log(item.replace('\n', ''))
                    if (item.trim() != "") {
                         let frml = objString.trim().split('endrule')[i].replace('\n', '') + "endrule"
                         let dsply = item.trim().replace('\n', '') + "endrule"
                         finalArray.push(frml + " " + dsply)
                    }
                    // finalArray.push(item.replace('\n', ''))
               })
               console.log(finalArray)
               let response: any;
               // if(prevData && prevData.length > 0){
               //response = await postRules(selectedFormId, finalArray,'put');
               // }else{
               response = await postRules(selectedFormId, finalArray, "post");
               //}
               if (response?.success) {
                    fetchRules(selectedFormId)
                    showToaster(toasterTypes.SUCCESS, "Rules added successfully");
                    // props.onClose();
               }

          } catch (error) {
               showToaster(toasterTypes.ERROR, "Rules adding failed");
               console.log(error)
          }
     }


     /**
  * get variables data
  * @param formData 
  */
     const fetchFormVariables = async (formData) => {
          try {
               dispatch(setLoading(true));
               let response = await getFormVariables(formData);
               setformVariables([]);
               //setformVariablesValue(response.data);
               let tempArray: any = [];
               response.data.map((item, i) => {
                    let Obj = {
                         label: item.field_name,
                         value: item.id,
                         field_value: item.field_value,
                         field_type: item.field_type
                    }
                    tempArray.push(Obj)
                    //setformVariables(prevState => [...prevState, Obj]);
               })
               setformVariables(tempArray);

               if (prevData && prevData.length != 0) {
                    fetchPrevious(tempArray);
               }

               dispatch(setLoading(false));
               return tempArray;

          } catch (e: any) {
               setformVariables([]);
               dispatch(setLoading(false));
          }
     }

     /**
      * add rules
      */
     const addRules = () => {
          let Obj = {
               id: rules.length == 0 ? 1 : rules[rules.length - 1]["id"] + 1,
               variable: "",
               operator: "",
               uservalue: "",
               logicoperator: "",
               variabledata: ""
          }
          Setrules(prevState => [...prevState, Obj])
     }

     /**
  * remove items 
  */
     const removeRules = (itemid) => {
          console.log(itemid)
          let updatedArray = rules.filter(item => item.id != itemid)
          console.log(updatedArray)
          Setrules(updatedArray)
     }


     /**
      * handle rule change on editor
      */
     let i = 0;

     const handleCodeChange = (newCode: string, value: any, position: any) => {
          setCode(newCode);
          console.log(position)
          let valueCode = value.changes[0].text;
          let offset = value.changes[0].rangeOffset;
          console.log(valueCode.length)
          console.log(tempCode, data)

          // console.log(newCode)
          if (valueCode.length != 0) {
               let specialCharExist = ComputeOperators.filter(items => items.value.trim() == valueCode.trim())
               if (specialCharExist.length > 0) {
                    let previousIndex;
                    if (newCode == "newline") {
                         previousIndex = data.lastIndexOf("end", data.length - 1);
                         console.log("---?", previousIndex + 2, data.length)
                    } else {
                         previousIndex = data.lastIndexOf("$$", data.length - 1);
                    }
                    let pd = data.slice((previousIndex > -1) ? previousIndex + 2 : 0, data.length);

                    if (pd) {
                         console.log("pd", pd.trim())
                         let matchs: any;
                         if (specialCharExist[0].label == specialCharExist[0].value) {
                              matchs = specialCharExist.filter(items => items.value.toLowerCase().includes(pd.trim()))
                              console.log("Match", matchs)
                         }
                         else {
                              matchs = specialCharExist.filter(items => items.label.toLowerCase().includes(pd.trim()))
                              console.log("Match1", matchs)
                         }


                         if (matchs.length > 0) {
                              if (previousIndex !== -1) {
                                   console.log(pd)
                                   data = data.slice(0, previousIndex + 2) +
                                        data.slice(previousIndex + 2 + pd.length);
                              } else {
                                   data = data.slice(pd.length);
                              }
                         } else if (pd != "$$") {
                              data += "$$";
                         }
                    }


                    data += valueCode.trim() + "$$";
                    console.log(data)
               } else {
                    console.log(valueCode)
                    if (valueCode == " " && valueCode.length != 0) {
                         if (data.slice(data.length - 2, data.length) !== "$$") {
                              data += "$$";
                         }
                    } else if (newCode == "newline") {
                         if (data.slice(data.length - 2, data.length) !== "$$") {
                              data += "\n$$";
                         }
                    } else {
                         // let newValue = newCode.split(" ");
                         // let lengthValue = newValue.length;
                         data += valueCode;
                    }
               }

               console.log(data)

               settempCode(data);
               //settempCode(tempCode+valueCode+"$$")
               let filterData = newCode.split(" ");
               let specialCharacter = ComputeOperators.filter(items => items.value == filterData[filterData.length - 1] || items.value == newCode[newCode.length - 1])
               if (specialCharacter.length > 0) {
                    //check if already space exist after last character
                    if (specialCharacter[0].value.length == 1 && newCode[newCode.length - 2] != " ") {
                         setCode(newCode.replace(/(?=.{1}$)/, ' ') + ' ');
                    } else if (specialCharacter[0].value.length == 2 && newCode[newCode.length - 1] != " ") {
                         setCode(newCode.replace(/(?=.{1}$)/, ' ') + ' ');
                    } else {
                         setCode(newCode + ' ');
                    }
               } else {
                    if (valueCode.length == 0) {
                         setCode(newCode);
                    } else {
                         setCode(newCode);
                    }
               }
          } else {

               // console.log(offset)
               // console.log(newCode.charAt(offset))
               let s = data.split("$$").length - 1
               const previousIndex = data.lastIndexOf("$$", offset + s);

               const nextIndex = data.indexOf("$$", offset + s);
               console.log(data.length)
               if (nextIndex !== -1) {
                    if (previousIndex !== -1) {
                         data = data.slice(0, previousIndex) +
                              data.slice(nextIndex);

                    } else {
                         data = data.slice(0, 0) +
                              data.slice(nextIndex);
                    }
               } else if (previousIndex === data.length - 2) {
                    let p = data.lastIndexOf("$$", previousIndex - 1);
                    if (p !== -1) {
                         data = data.slice(0, p) +
                              data.slice(previousIndex);
                    } else {
                         data = "";
                    }
               } else {
                    if (previousIndex !== -1) {
                         data = data.slice(0, data.length - 1);

                    } else {
                         data = data.slice(0, data.length - 1);
                    }

               }

          }
          let d2 = data.replaceAll("$$", " ");
          console.log("*******************", d2);
          console.log("*******************Data", data);


          settempCode(data);
          setCode(d2);
          setlineData(position)
          console.log(newCode);
          console.log(data)
     };

     return (
          <ModalComponent
               width={"90%"}
               isOpen={true}
               onClose={() => props.onClose()}
               header={"Add Rules"}
               centered={true}
               customClass='rule-modal'
               body={
                    <>
                         <div className="code-editor">

                              <Col md={12}>
                                   <MonacoEditorWrapper
                                        language="typescript"
                                        suggest={ComputeOperators}
                                        value={code}
                                        onChange={handleCodeChange}
                                   />
                              </Col>

                              <Col>
                                   <div className="rule-note">
                                        <span>Please follow the format mentioned here</span>
                                        {/* <i onClick={() => setmoreOption(!moreOption)}></i><i className={moreOption ? "icon icon-close" : "icon icon-question"} onClick={() => setmoreOption(!moreOption)}></i> */}

                                        <div className={moreOption ? "more-options-open" : "more-options"} >


                                             <div className="more-container" onClick={() => setmoreOption(false)}>
                                                  <div className="p-2">
                                                       <p><b>Syntax:-</b> Rule Type : Target Variable : Condition : Error Message : endrule</p>
                                                       <p><b>Validation Rule Example:- </b> validationrule : StartDate : {`StartDate < EndDate : 'Start date should be lesser than End Date' : endrule`}</p>
                                                       <p><b>Auto Fill Rule Example:- </b> autofillrule : Age : Current Date - DOB : 'DOB cannot be empty' : endrule`</p>
                                                       <p><b>Alert Rule Example:- </b> alertrule : Diabetes : Diabetes  {'>'} 240 : red : endrule`</p>

                                                       <b>Note:</b>
                                                       <ul>
                                                            <li>1. After endrule press enter to create new rule</li>
                                                            <li>2. Make use of predefined functions like current date if required</li>
                                                       </ul>
                                                       <dl>
                                                            <dt>Rule Type</dt>
                                                            <dd>Select rule type either validation or auto fill</dd>
                                                            <dt>Target Variable</dt>
                                                            <dd>Select variable for which you are applying rule</dd>
                                                            <dt>Condition</dt>
                                                            <dd>Create condition to be applied for variable</dd>
                                                            <dt>Error Message / Color</dt>
                                                            <dd>Error message to display if conditon fails and for alert rule add color code by typing color and select</dd>
                                                            <dt>End Rule</dt>
                                                            <dd>End rule need to be added to close the rule</dd>
                                                       </dl>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </Col>

                         </div>
                    </>
               }
               footer={
                    <div>
                         <CustomButton
                              type="primary"
                              isDisabled={false}
                              text={prevData && prevData.length > 0 ? `Update` : `Create`}
                              onClick={() => onAdd()}
                         ></CustomButton>
                    </div>
               }
          />
     );
};

export default CreateRules;